"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModifiedEntriesOperation = exports.MuleComponentType = exports.MAX_PAGE_SIZE = exports.EntryStatus = exports.MuleEntriesMarksQueryParamsUser = exports.MuleEntriesMarksQueryParamsSortTypes = void 0;
var MuleEntriesMarksQueryParamsSortTypes;
(function (MuleEntriesMarksQueryParamsSortTypes) {
    MuleEntriesMarksQueryParamsSortTypes["NAME"] = "NAME";
    MuleEntriesMarksQueryParamsSortTypes["NUMBER"] = "NUMBER";
    MuleEntriesMarksQueryParamsSortTypes["MARK"] = "MARK";
})(MuleEntriesMarksQueryParamsSortTypes = exports.MuleEntriesMarksQueryParamsSortTypes || (exports.MuleEntriesMarksQueryParamsSortTypes = {}));
var MuleEntriesMarksQueryParamsUser;
(function (MuleEntriesMarksQueryParamsUser) {
    MuleEntriesMarksQueryParamsUser["CENTRE_USER"] = "CentreUser";
    MuleEntriesMarksQueryParamsUser["MODERATOR"] = "Moderator";
})(MuleEntriesMarksQueryParamsUser = exports.MuleEntriesMarksQueryParamsUser || (exports.MuleEntriesMarksQueryParamsUser = {}));
var EntryStatus;
(function (EntryStatus) {
    EntryStatus["active"] = "Active";
    EntryStatus["inActive"] = "InActive";
})(EntryStatus = exports.EntryStatus || (exports.EntryStatus = {}));
exports.MAX_PAGE_SIZE = '100';
var MuleComponentType;
(function (MuleComponentType) {
    MuleComponentType["MODERATED"] = "Y";
    MuleComponentType["EXAMINED"] = "N";
})(MuleComponentType = exports.MuleComponentType || (exports.MuleComponentType = {}));
var ModifiedEntriesOperation;
(function (ModifiedEntriesOperation) {
    ModifiedEntriesOperation["DELETE"] = "Delete";
    ModifiedEntriesOperation["MODIFY"] = "Modify";
})(ModifiedEntriesOperation = exports.ModifiedEntriesOperation || (exports.ModifiedEntriesOperation = {}));
